const sendToGA = ({ eventCategory, eventAction, eventLabel }) => {
	ga('send', 'event', {
		eventCategory,
		eventAction,
		eventLabel,
	});
};

const initGA = () => {
	const gaConfig = [
		{
			elementClass: 'js-ga-login',
			eventCategory: 'tlacitko',
			eventAction: 'prihlasit_se',
			eventLabel: 'seznam_partner',
		},
		{
			elementClass: 'js-ga-partner',
			eventCategory: 'tlacitko',
			eventAction: 'chci_zacit_vydelavat',
			eventLabel: 'seznam_partner',
		},
		{
			elementClass: 'js-ga-news',
			eventCategory: 'tlacitko',
			eventAction: 'chci_se_zapojit',
			eventLabel: 'seznam_newsfeed',
		},
		{
			elementClass: 'js-ga-media',
			eventCategory: 'tlacitko',
			eventAction: 'zjistit_vice',
			eventLabel: 'medialni_partnerstvi',
		},
	];

	gaConfig.forEach((config) => {
		const btn = document.querySelector(`.${config.elementClass}`);

		if (!btn) {
			return;
		}

		btn.addEventListener('click', () => {
			sendToGA(config);
		});
	});
};

export default initGA;
